<template>
  <f7-page id="reg-details" name="reg-details" @page:beforein="init()" @page:afterin="afterin" class="bg-color-white">
    <f7-navbar class="view-mobile no-border bg-color-white">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
      <div class="mb-20">
        <div class="wandr-level-4 mt-lg mb-sm">{{$t('general-btn-register')}}</div>
      </div>

      <transition name="fade" class="">
        <f7-card
            class   ="alert alert-danger mb-20"
            v-show  ="alertCard.show"
        >
          <f7-card-header>
            <span v-html="alertCard.title"></span>
          </f7-card-header>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
      </transition>

      <f7-button large fill class="myinfo-official-btn mb-20" @click="singpassRegister" :disabled="false">
        <img :src="require('@/assets/img/icon/retrieve-myinfo-singpass-btn-primary.png')" alt="Register with Singpass" class="myinfo-official-btn-img" />
      </f7-button>

      <div class="text-align-center mb-xl">
        <div class="div-button ios mb-20" @click="openAppleSignIn"><f7-icon f7="logo_apple" size="20px" class="mr-sm"></f7-icon> {{$t('general-text-apple-sign-up')}}</div>

        <div class="div-button google" @click="openGoogleSignIn">
          <img :src="require('@/assets/img/icon/icon-google-colors.svg')" style="height:20px" class="mr-sm"/> {{$t('general-text-google-sign-up')}}
        </div>        
      </div>

      <div class="mb-20 divider-line">
        <span>{{$t('general-text-or')}}</span>
      </div>

      <div class="">
        <div class="mb-20 fs-16 b">{{ $t('regis-register-manually-text') }}</div>

        <f7-list class="form-group" style="">
          <f7-list-input
            input-id      ="email"
            name          ="email"
            type          ="email"
            class         =""
            placeholder   =""
            @input        ="validateInput($event.target);validateNextButton();"
            :label        ="$t('general-text-email')"
            :value        ="email"
            autocomplete  ="off"
            outline
            floating-label
            clear-button
            required
          >

          </f7-list-input>

          <f7-list-input
            input-id      ="password"
            name          ="password"
            :type         ="passwordInputType"
            class         ="password"
            placeholder   =""
            @input        ="password = $event.target.value;validateInput($event.target);validateNextButton();"
            minlength     ="8"
            :label        ="$t('general-text-password')"
            outline
            floating-label
            required
          >
            <div class="toggle-password" @click="showHidePassword('password')" id="password-icon" toggle="#password-field" slot="content-end" style="">
              <i class="f7-icons">eye_slash</i>
            </div>
          </f7-list-input>

          <f7-list-input
            input-id      ="password2"
            name          ="password2"
            :type         ="password2InputType"
            class         ="password"
            placeholder   =""
            @input        ="password2 = $event.target.value;validateInput($event.target);validateNextButton();"
            minlength     ="8"
            :label        ="$t('general-text-reenter-password')"
            outline
            floating-label
            required
          >
            <div class="toggle-password" @click="showHidePassword('password2')" id="password-icon2" toggle="#password-field2" slot="content-end" style="">
              <i class="f7-icons">eye_slash</i>
            </div>
          </f7-list-input>
        </f7-list>
      </div>

      <div id="reg-slide-captcha-container">
        <SlideVerify :l="42"
          :r="10"
          :w="320"
          :h="180"
          :slider-text="$t('captcha-slider-text')"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          @invalid="onFormInvalid"
          page="register"
          :email-valid="isEmailValid"
          :password-valid="isPasswordValid"
          :password2-valid="isPassword2Valid"
          ref="sliderCaptcha"
          :key="componentKey"
          v-if="isRenderCaptcha"
          >
        </SlideVerify>
        <div>{{msg}}</div>
      </div>

      <div class="my-2 re-anchor-wrapper">
        <Recaptcha v-if="isShowRecaptchaV2 && sitekeyV2 != ''" :sitekey="sitekeyV2" name="login" @validate-form="validateNextButton"/>
      </div>

      <f7-button class="mb-sm mt-xl" large fill @click="goToNextPage(false)" :disabled="!isNextButtonValid">
        {{$t('general-btn-register')}}
      </f7-button>      

    </f7-block>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import Recaptcha from '../../components/Recaptcha.vue';
  import SlideVerify from '../../components/SlideVerify.vue';
  import ApiService from "../../services/api-main";
  import CryptoAES from 'aes-ecb'
  import store from '../../store'
  import { check, dateHelper } from '@/plugins/helper';

  export default {
    mounted (){
      // const appRedirPath = this.$api.misc.checkDeviceRedirect()
      // if(appRedirPath){ window.location.href = appRedirPath; return; }
      this.determineAppBranchId(this.$f7.device.desktop)
      const rc = this.$f7route.query['rc'];

      if(rc && rc.trim() != ""){
        this.setReferral(rc);
      }

      this.getRecaptchaKey().then(()=>{
        if(this.sitekey != "" && this.sitekeyV2 != ""){
            this.loadScriptByURL("recaptcha-key", "https://www.google.com/recaptcha/api.js?render="+this.sitekey, function () {
              console.log("script loaded");
            });

            var registrationData = store.state.registration;
            registrationData.recaptchaV2 = "";

            this.forceRerender();
            //this.setCustomerAlias("")
        }
      });

      this.setSingpassUrl("");
      window.regMyInfoComplete = this.regMyInfoComplete
      window.checkClosedWindowState = this.checkClosedWindowState

    },
    data() {
      return {
        //email                 : "",
        password              : "",
        password2             : "",
        sitekey               : "",
        sitekeyV2             : "",
        recaptcha             : "",
        recaptchaV2           : "",
        isEmailValid          : false,
        isPasswordValid       : false,
        isPassword2Valid      : false,
        isNextButtonValid     : false,
        isShowRecaptchaV2     : false,
        isCaptchaVerified     : false,
        msg                   : "",
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        passwordInputType     : "password",
        password2InputType    : "password",
        isSingpass            : false,
        isOpenMyInfoPopup     : false,
        registerMyInfoUrl     : "",
        checkWindow           : undefined,
        checkTimer            : null,
        singpassKey           : 0,
        isForceClosed         : true,
        isRenderCaptcha       : false,
        componentKey          : 0,
        isCaptchaRefreshed    : false,
      };
    },
    methods: {
      ...mapActions('registration', [
            'getRecaptchaKey',
            'getToken',
            'getRegisterMyInfoUrl',
            'setSingpassUrl',
            'setReferral',
            'setIsAxsr',
        ]),

      ...mapActions('myinfo', [
        'setAddress',
        'setDob',
        'setEmail',
        'setEmployerName',
        'setEmploymentSector',
        'setFullname',
        'setGender',
        'setIdentificationNo',
        'setNationality',
        'setOccupation',
        'setPassExpiryDate',
        'setPassStatus',
        'setPassType',
        'setResidentialStatus',
        'setEnabledField',
        'setMyInfoState',
        'setMyInfoCode',
      ]),
      ...mapActions('misc', ['determineAppBranchId']),
      ...mapActions('auth', ['logout']),
      ...mapActions('customer', ['setCustomerAlias']),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async init(){
        //await this.logout();
        await this.forceRerender();
        //this.setCustomerAlias("");

        // this.f7Method = {
        //   loginAppleNotice: this.$f7.dialog.create({
        //     title: '',
        //     cssClass: 'single-button',
        //     text: '<div class="display-flex text-align-center mb-xl ml-sm mr-sm">' + this.$t('login-apple-notice') + '</div><div class="mt-xl">',
        //     buttons : [{text: this.$t('general-ok-text'), cssClass: '', onClick: this.openAppleSignIn}]
        //   }),
        // }

        this.setIsAxsr(false)
        console.log("Register enter details isAxsr : "+this.isAxsr);
      },

      async getRecaptchaKey(){
        this.showPreloader();
        const recaptchaKey = await this.$api.registration.getRecaptchaKey();
        //const recaptchaKey = {"status":"1223","message":null,"result":{}}

        if(recaptchaKey){
          if(recaptchaKey.result.siteKey && recaptchaKey.result.siteKeyV2){
            console.log("GOT THE SITEKEY")
            this.sitekey = recaptchaKey.result.siteKey;
            this.sitekeyV2 = recaptchaKey.result.siteKeyV2;
            this.hidePreloader();
          }else{
            console.log("DISPLAY ERROR MSG FOR SITEKEY NULL")
            this.hidePreloader();
            this.$f7.dialog.alert(this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
          }
        }else{ // recaptchaKey == false -> WS error
          this.sitekey = "";
          this.sitekeyV2 = "";
        }
        this.hidePreloader();

      },
      validateInput(e) {
        var inputName   = e.name;
        var inputValue  = "";
        var keyName     = "regis-"+e.name;
        var translation;

        if(e.name == "email"){
          this.$store.state.registration.email = e.value
          inputValue = this.email;
        }else if(e.name == "password"){
          inputValue = this.password;
        }else{
          inputValue = this.password2;
        }

        if (inputValue.trim() == ""){
          translation = keyName + "-empty";
          this.setInputState(inputName, this.$t(translation));
          return false;
        }

        //var regex = /^[0-9]{6}$/;
        var validate = false;
        if (inputName == "email"){
          //regex = /^[_a-z0-9-]+([_+.a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9]+)*(\.[a-z]{2,})$/i
          validate   = check.validPattern("email", e.value);
        } else if(inputName == "password" || inputName == "password2"){
          validate   = check.validPattern("password", e.value);
        }

        if(!validate){
          translation = keyName + "-rule";
          this.setInputState(inputName, this.$t(translation));
          if(inputName == "email"){
            this.isEmailValid = false;
          }else if(inputName == "password"){
            this.isPasswordValid = false;
          }else if(inputName == "password2"){
            this.isPassword2Valid = false;
          }
          this.isNextButtonValid = false;
          return false;
        }

        if(inputName == "email"){
          this.isEmailValid = true;
        }else if(inputName == "password"){
          this.isPasswordValid = true;
        }else if(inputName == "password2"){
          this.isPassword2Valid = true;
        }



        if (inputName == "password"){
            if(this.password2.trim() != ""){
                if( this.password != this.password2){
                  translation = keyName + "2-mismatch";
                  this.setInputState("password2", this.$t(translation));
                  this.isPassword2Valid = false;
                  this.isNextButtonValid = false;

                  if(validate){
                      this.isPasswordValid = true;
                      this.setInputState("password", true);
                  }
                  return false;
                }else{
                  this.isPasswordValid = true;
                  this.isPassword2Valid = true;
                  this.setInputState("password", true);
                  this.setInputState("password2", true);
                }
            }
        }


        if (inputName == "password2"){
          if( this.password != this.password2){
            translation = keyName + "-mismatch";
            this.setInputState(inputName, this.$t(translation));
            this.isPasswordValid = false;
            this.isPassword2Valid = false;
            this.isNextButtonValid = false;
            return false;
          }else{
            this.isPasswordValid = true;
            this.isPassword2Valid = true;
          }
        }

        this.setInputState(inputName, true);
        return true;
      },
      async finalValidation(){
        await this.validateInput({name: "email", value: this.email});
        await this.validateInput({name: "password", value: this.password});
        await this.validateInput({name: "password2", value: this.password2});
      },
      loadScriptByURL(id, url, callback){
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      },
      validateNextButton(){
        var isRecaptchaValid = false;

        if(!this.isShowRecaptchaV2 && this.sitekey != ""){
          isRecaptchaValid = true;
        }else if(this.isShowRecaptchaV2 && this.sitekeyV2 != ""){
          var registrationData = store.state.registration;
          if(registrationData.recaptchaV2.trim() != ""){
            isRecaptchaValid = true;
          }
        }

        this.isNextButtonValid = this.isEmailValid && this.isPasswordValid && isRecaptchaValid && this.isCaptchaVerified
      },
      async goToNextPage(isSingpass){
        if(isSingpass){
          const self = this;
          self.showPreloader();

          const reqTokenSingpass = await this.$api.registration.getTokenSingpass();

          if(reqTokenSingpass.status == "WN00103"){
            const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
            const myInfoUrlPromise = await this.$api.registration.getRegisterMyInfoUrl(isUsingInAppBrowser);

            self.registerMyInfoUrl = myInfoUrlPromise.value;
            self.setSingpassUrl(myInfoUrlPromise.value);


            if(isUsingInAppBrowser) {
              self.openMyInfoInMobile(self.singpassUrl);
              self.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
                if(isUserCancel) {
                  self.regMyInfoCancel(false);
                } else {
                  self.regMyInfoComplete((state != '' && code != ''), state, code);
                }
              });
            } else if(self.checkWindow !== undefined) {
              self.checkWindow.location.replace(self.singpassUrl);
            } else {
              self.checkWindow = window.open(self.singpassUrl, '_blank', "fullscreen=1");
            }

            if(!isUsingInAppBrowser) {
              self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.regMyInfoCancel(false);} }, 1000);
            }
            //self.hidePreloader();
          }else{ // GENERAL EXCEPTION
            //this.showAlert(true, reqToken.status)
            this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            console.log("REQUEST REGISTER TOKEN ERROR! Status : "+reqTokenSingpass.status);
            this.hidePreloader();
          }
        }else{
          await this.finalValidation();

          if (this.isEmailValid && this.isPasswordValid && this.isPassword2Valid) {
            this.showPreloader();

            const randVal = await ApiService.getRandomValue();

            if(this.sitekey != "" && this.sitekeyV2 != ""){
              window.grecaptcha.ready(() => {
                window.grecaptcha.execute(this.sitekey, { action: 'submit' }).then(async token => {
                  //console.log("g-recaptcha-response : "+token);
                  this.recaptcha = token;
                  var recaptchaData = store.state.registration;
                  recaptchaData.recaptcha = token;

                  var secretKey = process.env.VUE_APP_PSSTK+randVal;
                  //console.log("secret key : "+secretKey)

                  var encryptedPassword = CryptoAES.encrypt(secretKey, this.password);
                  var encryptedPassword2 = CryptoAES.encrypt(secretKey, this.password2);

                  var registrationData = store.state.registration;
                  registrationData.email = this.email;
                  registrationData.password = encryptedPassword;
                  registrationData.password2 = encryptedPassword2;

                  const reqToken = await this.$api.registration.getToken(registrationData);

                  if(reqToken.status == "WN00103"){
                    this.$f7router.navigate("/register-tnc");
                    this.hidePreloader();
                  }else if(reqToken.status == "WN00101"){ // error recaptcha
                    console.log("ERROR RECAPTCHA -> display V2")
                    let $$ = this.Dom7;
                    $$("#reg-slide-captcha-container").hide();
                    this.isShowRecaptchaV2 = true;
                    this.validateNextButton();
                    this.hidePreloader();
                  }else if(reqToken.status == "WN00102"){ // email exist
                    this.showAlert(true, this.$t('regis-email-exist'));
                    this.hidePreloader();
                  }else{ // GENERAL EXCEPTION
                    //this.showAlert(true, reqToken.status)
                    this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
                    console.log("REQUEST REGISTER TOKEN ERROR! Status : "+reqToken.status);
                    this.hidePreloader();
                  }
                });
              });
            }else{ // failed to ge recatpcha sitekey
              this.showAlert(true, this.$t('general-ws-error-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}))
              this.hidePreloader();
            }

          }else{
            if(this.email != "" && this.password != "" && this.password2 != ""){
              this.showAlert(true, this.$t('login-invalid-email-pass'));
            }

            // refresh captcha
            this.$refs.sliderCaptcha.refresh()
            this.isCaptchaVerified = false;
            this.validateNextButton();
          }
        }
      },
      checkClosedWindowState(){
        console.log("checkClosedWindowState : "+this.checkWindow.closed)
        if(this.checkWindow.closed){
          console.log("child window closed")
        }
      },
      async regMyInfoComplete(isNextPage, myInfoState, myInfoCode){
        this.isForceClosed = false;
        this.setMyInfoState(myInfoState);
        this.setMyInfoCode(myInfoCode);
        this.closePopupOnMobile();
        this.isSingpass = false;
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }

        if(isNextPage){
          this.showPreloader();

          const myInfoDetailPromise = await this.$api.registration.getRegisterMyInfoDetail(this.isMyInfoUseInAppBrowser(), myInfoCode, myInfoState);

          if(myInfoDetailPromise.status == "4854"){
            const myInfoData = myInfoDetailPromise.result;

            this.setAddress(myInfoData.address.streetAddress);

            // FORMAT DOB
            const dobVal = new Date(myInfoData.dateOfBirth);
            var formattedToday = '';
            if(dobVal instanceof Date && !isNaN(dobVal)) {
              const yyyy = dobVal.getFullYear();
              let mm = dobVal.getMonth() + 1; // Months start at 0!
              let dd = dobVal.getDate();

              if (dd < 10) dd = '0' + dd;
              if (mm < 10) mm = '0' + mm;

              formattedToday = dd + '-' + mm + '-' + yyyy;
            }
            //console.log("formattedToday 1 : "+formattedToday)
            this.setDob(formattedToday);
            // END OF FORMAT DOB

            this.setEmail(myInfoData.email);
            this.setEmployerName(myInfoData.employer);
            this.setEmploymentSector(myInfoData.industry);
            this.setFullname(myInfoData.name);
            this.setGender(myInfoData.gender);
            this.setIdentificationNo(myInfoData.identificationNo);
            this.setNationality({id: myInfoData.nationalityId, name: myInfoData.nationality});
            this.setOccupation(myInfoData.occupation);
            this.setPassExpiryDate(dateHelper.formatDateOnly(myInfoData.idExpiryDate));
            this.setPassStatus(myInfoData.idStatus || "");
            this.setPassType(myInfoData.identificationType);
            this.setResidentialStatus({id: myInfoData.residentialStatusId, name: myInfoData.residentialStatus || ""});
            this.setEnabledField(myInfoData.enabledField);

            this.$f7router.navigate("/register-myinfo-verify-detail");
            this.hidePreloader();
          }else if(myInfoDetailPromise.status == "1214"){
            console.log("ID exist")

            // refresh captcha
            this.$refs.sliderCaptcha.refresh()
            this.isCaptchaVerified = false;
            this.validateNextButton();

            this.showAlert(true, this.$t('regis-id-already-exist-error', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            this.$f7router.navigate("/register");
            this.hidePreloader();

          }else if(myInfoDetailPromise.status == "0104"){
            console.log("general exception")

            // refresh captcha
            this.$refs.sliderCaptcha.refresh()
            this.isCaptchaVerified = false;
            this.validateNextButton();

            this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            this.$f7router.navigate("/register");
            this.hidePreloader();

          }else{
            console.log("get details: ERROR -> "+myInfoDetailPromise.status);
            this.$f7router.navigate("/register");
            this.hidePreloader();
          }


        }else{ // reload register enter details page
          console.log("reload page")
          //this.$f7router.navigate("/register");
          this.$f7router.refreshPage({
            url: '/register'
          });
          this.showAlert(true, this.$t('regis-myinfo-unavailable-error'));
        }
      },
      async regMyInfoCancel(isNextPage){
        this.isSingpass = false;
        if(!isNextPage){
          if(!this.isCaptchaRefreshed){
            // refresh captcha

            clearInterval(this.checkTimer);
            if(this.checkWindow !== undefined) {
              this.checkWindow.close();
              this.checkWindow = undefined;
            }

            await this.$refs.sliderCaptcha.refresh()
            this.isCaptchaVerified = false;
            await this.validateNextButton();
            this.isCaptchaRefreshed = true;

            this.hidePreloader();
          }

        }
      },
      forceRerender() {
        let $$ = this.Dom7;
        $$("#slide-captcha-container").show();
        this.isShowRecaptchaV2 = false;
        this.isRenderCaptcha = true;
        this.componentKey += 1;
      },
      onRefresh(){
        console.log("REFRESH Captcha Image")
        this.isCaptchaVerified = false;
      },
      onFinish(){
        console.log("finish verify captcha")
      },
      onSuccess(){
        console.log("SLIDE CAPTCHA VERIFY : SUCCESS")
        this.isCaptchaVerified = true;
        /*let $$ = this.Dom7;
        $$("#reg-slide-captcha-container").hide();
        this.goToNextPage()*/
        this.isNextButtonValid = true;
      },
      onFail(){
        console.log("fail verify captcha")
        this.isCaptchaVerified = false;
      },
      onFormInvalid(){
        this.alertCard.show    = true;
        this.alertCard.title   = this.$t('login-invalid-email-pass');
      },
      // openAppleSignInModal(){
      //   this.f7Method.loginAppleNotice.open();
      // },
      openAppleSignIn() {
        if(window.AppleID) {
          this.appleSignIn(2, false);
        }
      },
      openGoogleSignIn() {
        this.$googleAuth.requestAccessToken();
      },
      backButton() {
          switch(this.routerTo) {
              default          : this.$f7router.navigate("/"); break;
          }
      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      singpassRegister(){
        console.log("singpassRegister");
        const self = this;

        self.isSingpass = true;
        this.isCaptchaRefreshed = false;
        self.goToNextPage(true);
      },
      showHidePassword(el){
        let $$ = this.Dom7;

        if(el == "password"){
          if(this.passwordInputType == "password"){
            this.passwordInputType = "text";
            $$("#password-icon").html('<i class="f7-icons">eye</i>');
          }else{
            this.passwordInputType = "password";
            $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
          }

        } else if(el == "password2"){
          if(this.password2InputType == "password"){
            this.password2InputType = "text";
            $$("#password-icon2").html('<i class="f7-icons">eye</i>');
          }else{
            this.password2InputType = "password";
            $$("#password-icon2").html('<i class="f7-icons">eye_slash</i>');
          }
        }
      }
    },
    components: {
      Recaptcha,
      SlideVerify,
    },
    computed: {
      ...mapGetters('registration', ['singpassUrl','email','isAxsr']),
      ...mapGetters('myinfo', [
          'myInfoState',
          'myInfoCode',
        ])
    },
  }
</script>

<style scoped>
/* DR-1931 B.1: official SingPass "Retrieve Myinfo with Singpass" button asset —
   button reset only, no recolour/restyle of the asset itself (image scales
   proportionally via width:100%/height:auto, aspect ratio preserved). */
.myinfo-official-btn {
  background: none;
  border: none;
  padding: 0;
  height: auto;
}
.myinfo-official-btn-img {
  display: block;
  width: 100%;
  height: auto;
}
</style>